import { render, staticRenderFns } from "./RunCard.vue?vue&type=template&id=3def82fc&scoped=true&"
import script from "./RunCard.vue?vue&type=script&lang=js&"
export * from "./RunCard.vue?vue&type=script&lang=js&"
import style0 from "./RunCard.vue?vue&type=style&index=0&id=3def82fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3def82fc",
  null
  
)

export default component.exports